/**
 * StatusBadge — reusable colored badge for build and domain statuses.
 *
 * Accepts any status string and maps it to a translated label via i18n.
 * Unknown statuses fall back to a neutral gray style.
 */

import { useTranslation } from 'react-i18next';
import type { BuildStatus, DomainStatus } from '../types.ts';

type Status = BuildStatus | DomainStatus | string;

interface StatusBadgeProps {
  status: Status;
  /** Optional override for the displayed label. */
  label?: string;
}

export const StatusBadge = ({ status, label }: StatusBadgeProps) => {
  const { t } = useTranslation();
  const displayLabel = label ?? t(`status.${status}`, status);
  const modifier = status.toLowerCase().replace(/\s+/g, '_');

  return (
    <span className={`badge badge--${modifier}`} role="status" aria-label={displayLabel}>
      <span className="badge__dot" aria-hidden="true" />
      {displayLabel}
    </span>
  );
};
